export default "__VITE_ASSET__HSrOseFivlq9XBxiNU5wYA__"